import { render } from "./AppNavbar.vue?vue&type=template&id=44222f2d"
import script from "./AppNavbar.vue?vue&type=script&lang=js"
export * from "./AppNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__